<script setup lang="ts">
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header2 from '@/components/base/typography/Header2.vue';

const jeffreySignature = nutshell['static_img/about-us/jeffrey-signature.gif'];
const groupPhoto = nutshell['static_img/about-us/group-photo.jpg'];
</script>

<template>
  <div class="flex flex-col gap-4">
    <Header2>Our Guarantee</Header2>

    <BaseBodyText class="mt-2 font-semibold">
      Your Satisfaction. Guaranteed. Unconditionally.
    </BaseBodyText>

    <BaseBodyText>
      At Nuts.com we guarantee absolute satisfaction. If you experience any problem with any of our
      products, customer service, shipping, or even if you just plain don't like what you bought,
      please let us know. We'll do whatever it takes to make it right for you.
    </BaseBodyText>

    <BaseBodyText>
      To be honest, this is a matter of pride for my family and me. My Poppy Sol started this
      business in 1929. It brings tears to my eyes as children and grandchildren of Poppy's old-time
      customers still visit us today and share tales of their trips to our store and of my
      grandfather.
    </BaseBodyText>

    <BaseBodyText>
      We believe in doing things the old-fashioned way and having customers for life. This is what
      we live and breathe.
    </BaseBodyText>

    <BaseBodyText>
      My cousin David, my uncle Sandy, my dad Kenny, and I have been at this for nearly 150 years
      combined. We promise to bring a smile to your face.
    </BaseBodyText>

    <div class="flex justify-between">
      <div>
        <img alt="Jeffrey and Family signature" height="73" :src="jeffreySignature" width="107" />
        <BaseBodyText>Jeffrey and Family</BaseBodyText>
      </div>
      <img alt="David, Sandy, Kenny and Jeffrey" height="207" :src="groupPhoto" width="276" />
    </div>
  </div>
</template>
